import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgErrorIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="currentColor" d="M11 16a1 1 0 1 1 2 0 1 1 0 0 1-2 0m0-8a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0zm1-6C6.47 2 2 6.5 2 12A10 10 0 1 0 12 2m0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default SvgErrorIcon;